<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <div class="articleContent" v-if="detail.type === 'pdf'">
          <div id="dfCnt"></div>
        </div>
        <div class="articleContent image gallery" v-else-if="detail.type === 'gallery'">
          <div class="theImg" :style="{'background-image':
            `url(${detail.gallery[lang][gi].imageMd})`}" v-on:click="previewImgObject"></div>
          <div class="galleryNav p" v-if="gi > 0"
            v-on:click.stop="gi -= 1"></div>
          <div class="galleryNav n" v-if="gi < detail.gallery[lang].length - 1"
            v-on:click.stop="gi += 1"></div>
          <div class="galleryPager" v-on:click.stop="doNothing">
            <div class="pagerItem" v-for="(item, i) in detail.gallery[lang]" :key="i"
              v-on:click.stop="gi = i"
              :class="{active: i === gi}"></div>
          </div>
          <div class="downloadCnt">
            <a :href="detail.gallery[lang][gi].imageLg" target="_blank" download
              class="btn download" v-on:click="download">Download</a>
            <button class="btn openSlide" v-on:click="previewImgObject"></button>
          </div>
        </div>
        <div class="articleContent video" v-else-if="detail.type === 'video'
          && detail.media[lang] && detail.media[lang].mimetype === 'video/youtube'">
          <iframe :src="detail.embedUri[lang]" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media;
            gyroscope; picture-in-picture" allowfullscreen autoplay></iframe>
        </div>
        <div class="articleContent video" v-else-if="detail.type === 'video'">
          <VuePlyr ref="video" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
        <div class="articleContent audio" v-else-if="detail.type === 'audio'">
          <VuePlyr ref="audio" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  name: 'loadingDialog',
  components: {
    VuePlyr,
  },
  data() {
    return {
      show: false,
      detail: null,
      currentPage: 0,
      lang: 'id',
      gi: 0,
    };
  },
  methods: {
    previewImgObject() {},
    download() {},
    open(d, n) {
      this.show = true;
      this.detail = d.content;
      this.lang = d.lang;
      if (this.detail.type === 'pdf') {
        setTimeout(() => {
          let heightOff = 0;
          const winWidth = $(window).width();
          if (winWidth > 980) heightOff = 183;
          else heightOff = 165;
          const fbH = $(window).height() - heightOff;
          $('#dfCnt').flipBook(this.detail.media[this.lang].pdf, {
            backgroundColor: '#F1F6FF',
            scrollWheel: false,
            height: fbH,
            hideControls: 'share, download',
            onFlip: (fb) => {
              this.currentPage = fb.currentPage();
            },
            onReady: (fb) => {
              // if (this.$route.query.p) {
              //   setTimeout(() => {
              //     fb.gotoPage(this.$route.query.p);
              //   }, 1200);
              // }
            },
          });
        }, 500);
      } else if (this.detail.type === 'video') {
        if (this.detail.media[this.lang] && this.detail.media[this.lang].mimetype === 'video/youtube') return;
        const src = [];
        if (this.detail.media[this.lang].vid1080p) src.push({ src: this.detail.media[this.lang].vid1080p, type: 'video/mp4', size: 1080 });
        if (this.detail.media[this.lang].vid720p) src.push({ src: this.detail.media[this.lang].vid720p, type: 'video/mp4', size: 720 });
        if (this.detail.media[this.lang].vid480p) src.push({ src: this.detail.media[this.lang].vid480p, type: 'video/mp4', size: 480 });
        if (this.detail.media[this.lang].vid360p) src.push({ src: this.detail.media[this.lang].vid360p, type: 'video/mp4', size: 360 });
        setTimeout(() => {
          const v = this.$refs.video.player;
          v.source = { type: 'video', title: this.detail.title[this.lang], sources: src };
          v.play();
        }, 300);
      } else if (this.detail.type === 'audio') {
        const src = [{
          src: this.detail.media[this.lang].audio,
          type: this.detail.media[lang].mimetype,
        }];
        setTimeout(() => {
          const v = this.$refs.audio.player;
          v.source = { type: 'audio', title: this.detail.title[this.lang], sources: src };
          v.play();
        }, 300);
      }
    },
    close(b) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      text-align: center;
      overflow: hidden;
      max-width: none;
      border-radius: 5px;
      margin: -20px 10px 0;
      width: calc(100% - 20px);
      max-width: 1240px;
      @media (max-width: 1480px) {
        max-width: 960px;
      }
      .close{
        z-index: 9992;
        background-color: #fff;
      }
      #dfCnt{}
      .articleContent{
        &.image{
          height: 640px;
          position: relative;
          background-color: #222;
          min-height: calc(80vh);
          @media (max-width: 760px) {
            height: 520px;
          }
          @media (max-width: 680px) {
            height: 360px;
            min-height: 0;
          }
          .theImg{
            position: absolute;
            left: 40px; top: 40px; right: 40px; bottom: 40px;
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            cursor: pointer;
          }
          &.gallery{
            .theImg{
              bottom: 80px;
            }
            .downloadCnt{
              position: absolute;
              left: 0; right: 0; bottom: 10px;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 4;
              .btn{
                border: none;
                background-color: transparent;
                color: #fff;
                height: 40px;
                transition: all .3s ease;
                border-radius: 50px;
                margin: 0 4px;
                display: inline-block;
                font-weight: normal;
                font-size: 15px;
                outline: 0;
                &:hover{
                  background-color: #222;
                }
                &.download{
                  padding: 0 20px;
                  line-height: 40px;
                  padding-left: 54px;
                  position: relative;
                  background-color: #333;
                  &:hover{
                    background-color: #222;
                  }
                  &:before{
                    content: "";
                    position: absolute;
                    left: 20px; top: 7px;
                    width: 20px; height: 20px;
                    background-size: 20px auto;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url(../assets/download-white.png);
                  }
                }
                &.openSlide{
                  width: 40px;
                  background-size: 28px auto;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-image: url(../assets/maximize-white.png);
                }
              }
            }
          }
          .galleryNav{
            position: absolute;
            top: 50%;
            width: 30px; height: 30px;
            background-color: #fff;
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            margin-top: -15px;
            border-radius: 50%;
            opacity: .65;
            cursor: pointer;
            transition: all .3s ease;
            z-index: 3;
            &:hover{
              opacity: 1;
            }
            &.p{
              left: 30px;
              background-image: url(../assets/left-arrow.png);
              @media (max-width: 680px) {
                left: 15px;
              }
            }
            &.n{
              right: 30px;
              background-image: url(../assets/right-arrow.png);
              @media (max-width: 680px) {
                right: 15px;
              }
            }
          }
          .galleryPager{
            position: absolute;
            bottom: 60px;
            display: flex;
            left: 0; right: 0;
            justify-content: center;
            .pagerItem{
              width: 8px; height: 8px;
              background-color: #ccc;
              border-radius: 50%;
              margin: 0 2px;
              cursor: pointer;
              &.active{
                background-color: #0057d8;
              }
            }
          }
        }

        &.video{
          height: 640px;
          position: relative;
          background-color: #000;
          @media (max-width: 1200px) {
            height: 60vw;
          }
          iframe{
            width: 100%; height: 100%;
          }
        }
        &.audio{
          border: #eee 1px solid;
          max-width: 1180px;
          margin: 0 auto;
          @media (max-width: 1300px) {
            max-width: 1140px;
          }
          @media (max-width: 1220px) {
            margin: 0 20px;
          }
          @media (max-width: 680px) {
            margin: 0 16px;
          }
        }
      }

    }
  }
</style>
